<template>
  <div class="container-fluid login" style="background:url('static/assets/images/login/bg1.jpg');">
      <div class="row ">
          <div class="col-sm-5 login-box align-self-center">
               <div class=" v-middle align-content-center no-gutters pb-70">
                <img class="login-logo" src="static/assets/images/mfs-logo.png" alt="">
                    <div class="title-heading">
                    <h1>{{$t('login.lblHeading1')}}</h1>
                    <p >{{$t('login.lblHeading2')}}</p>
                    </div>
                   <div class="col-sm-12">
                    <form>
                        <!-- <div class="user-img">
                            <img class="rounded-circle img-fluid" src="static/assets/images/user.png" alt="">
                        </div>
                        <div class="form-group custom-form">
                            <label for="username">Email address</label>
                            <input type="text" class="form-control" id="username" aria-describedby="emailHelp" placeholder="Enter Username">
                            <small id="emailHelp" class="form-text text-muted sr-only">We'll never share your email with anyone else.</small>
                        </div>
                        <div class="form-group custom-form">
                            <label for="exampleInputPassword1">Password</label>
                            <input type="password" class="form-control" id="exampleInputPassword1" placeholder="Password">
                        </div>
                        <a href="#" class="forgot-link btn-link">Forgot Username & Password</a><br>-->
                        <button type="button" @click="signUp" class="btn btn-orange mr-2">{{$t('button.signUp')}}</button>
                        <!-- <button type="button" @click="loginWithMkcl" class="btn btn-orange">{{$t('button.login')}}</button>
                         -->
                         <b-dropdown id="ddown1" right text="Login" class="btn-orange-wrapper">
                         <b-dropdown-item show @click="loginWithMkcl(MFS_APPLICANT_ID)">{{$t('login.lblApplicant')}}</b-dropdown-item>
                         <b-dropdown-item show @click="loginWithMkcl(MFS_INDUSTRY_PARTNER_ID)">{{$t('login.lblIP')}}</b-dropdown-item>
                         <b-dropdown-item show @click="loginWithMkcl(MFS_ASC_ID)">{{$t('login.lblASC')}}</b-dropdown-item>
                         </b-dropdown>
                    </form>
                   </div>
                        <div class="text-left mt-4 start-date">
                         <h5 v-if="currentServerDate.getTime() < applicationStartDate.getTime()">{{$t('registration.lblStartReg')}} <b>{{applicationStartDate | formatDate}}</b></h5>
                         <h5 v-if="currentServerDate.getTime() >= applicationStartDate.getTime() && currentServerDate.getTime() <= applicationEndDate.getTime()" >{{$t('registration.lblGoingReg')}}<b>{{applicationEndDate | formatDate}}</b></h5>
                         <h5 v-if="currentServerDate.getTime() > applicationEndDate.getTime()"><span class="red">{{$t('registration.lblEndReg')}} <b>{{applicationEndDate | formatDate}}</b></span></h5>
                        </div>
                </div>     
          </div>
          <!--mkcl logo -->
               <div class="logo-box">
          <img class="mkcl-logo" src="static/assets/images/logo_mkcl-s.png" alt="">
          <img class="mkcl-logo right" :src="getLogoUrl(universityConfig.abbr)" alt="">
          </div>
      </div>
  </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
export default {
  name: 'login',
  data () {
    return {
      user: {},
      universityConfig: { state: {} },
      userExists: false,
      currentServerDate: '',
      applicationStartDate: '',
      applicationEndDate: ''
    }
  },
  computed: {
    isUserExists () {
      return this.userExists
    }
  },
  methods: {
    signUp () {
    //   if (this.currentServerDate < this.applicationEndDate) {
    //     this.toasted.error('Registration has been closed on date : ')
    //     return false
    //   } else {
      this.$router.push('signup')
    //  }
    },
    loginWithMkcl (clientId) {
      // window.MKCLAPI.login()
      window.MKCLAPI.switchAppWithSingleSignOn(clientId)
    },
    getLogoUrl (abbr) {
      return 'static/assets/images/' + abbr + '.png'
    },
    // getUser () {
    //   axios
    //     .post(window.lcmsserver + '/o/lcmslogin/getuser', this.user)
    //     .then(response => {
    //       console.log('login response = ' + JSON.stringify(response))
    //       if (response != null && response.data === 'User_Not_Found') {
    //         // Vue.toasted.error('Invalid UserName', {
    //         //   theme: 'bubble',
    //         //   duration: 6000
    //         // })
    //         alert(response)
    //         this.userExists = false
    //       } else {
    //         this.userExists = true
    //       }
    //     })
    //     .catch(e => {
    //       console.log(e)
    //       this.userExists = false
    //       alert('Something went wrong while login')
    //     })
    //   this.userExists = true
    // },
    login () {
      this.$store.dispatch('validateUser', this.user)
    },
    getProjectConfig () {
      axios.get('o/projectConfig/getUniversityConfig').then(response => {
        this.universityConfig = response.data
      }).catch(function (e) {
        console.error(e)
      })
    // This method get application start date and end date.
      axios.get('o/projectConfig/getStartEndDate').then(responses => {
        this.applicationStartDate = new Date(responses.data.startDate)
        this.applicationEndDate = new Date(responses.data.endDate)
        axios.get('o/projectConfig/getCurrentServerDateTime').then(response => {
          this.currentServerDate = new Date(response.data)
        }).catch(function (e) {
          console.error(e)
        })
      }).catch(function (e) {
        console.error(e)
      })
    },
    backToLoginForm () {
      this.userExists = false
    }
  },
  created: function () {
    window.sessionStorage.removeItem('vuex')
    window.localStorage.clear()
    window.sessionStorage.clear()
    this.$store.commit('STORE_CLEAR_ALL')
    window.MKCLAPI.deleteAllCookies()
    window.document.title = 'Login Page'
    this.getProjectConfig()
  },
  filters: {
    formatDate (value) {
      if (value) {
        return moment(String(value)).format('DD-MMM-YYYY')
      }
    }
  }
}
</script>
<style lang="scss">
// @import 'static/assets/styles/scss/variables';
.btn-orange-wrapper .btn{
    color: white;
    background: #fe763a;
    border-radius: 50px;
    border: 1px solid #fe6421;
    font-size: 12px;
    padding: 8px 26px;
    font-weight: 500;
    transition: 300ms ease;
    text-transform: uppercase;
    transition: all 0.2s;
}

    .login{
            padding: 0;
            // background:url('static/assets/images/login/bg1.jpg');
            margin-left: 0;
            overflow:hidden;
            position: relative;
            &:before{
                position: absolute;
                content:"";
                top:0;
                left:0;
                width: 100%;
                height: 100%;
                background: rgba(0,0,0,0.4);
            }
        
        .login-box{
            background: #fff;
            height:100vh;
            position: relative;
            padding:0 50px;
           & >.row{
               height: 100vh;
           }
            &:before{
                left: 100%;
                top: 0;
                border: solid transparent;
                content: " ";
                height: 0;
                width: 0;
                position: absolute;
                pointer-events: none;
                border-color: rgba(136, 183, 213, 0);
                border-left-color: #fff;
                border-width: 60vh 35vh;
                margin-top: 0px;
            }
            .title-heading{
                margin-bottom: 2rem;
            h1{
                
                text-transform: uppercase;
                font-size: 1.8rem;
                
            }
            p{
                    color: #999;
                    font-weight: 300;
            }
            }
            .custom-form{
                border:1px solid #ddd;
                padding: 15px;
                margin-bottom: 0;
                label{
                    font-size:12px;
                    color:#999;
                    margin-bottom: 0;
                }
                .form-control{
                    border:none;
                    padding: 0;
                    text-transform: uppercase;
                    color:#333;
                    font-weight: 500;
                    &:focus{
                        box-shadow:none !important;
                    }
                }
            }
            .user-img{
                width:100px;    
                margin-bottom: 1.5rem;
                border: 2px solid #eee;
                border-radius: 50%;
                padding: 6px;
            }
            .forgot-link{
                margin: 1rem 0;
                display: block;
                font-size: 14px;
                text-decoration: none;
                color: #999;
                font-weight: 500;
                &:hover{
                    color:#007bff;
                }
                .btn-orange{
                    padding: 10px 40px;
                }
            }
            .v-middle{
                position: absolute;
                width: 60%;
                top: 50%;
                left: 50%;
                transform: translate(-50%,-50%);
                z-index: 10;
                .login-logo{
                        width: 150px;
                        margin-bottom: 20px;
                    }
            }
        }
    }

// #login {height: 100vh;}
.logo-box{
    position: absolute;
    left: 10px;
    width: 46%;
    bottom: 10px;
    z-index: 111;   
    img{ height:60px; }
    .right{
      float: right;
    }
}
.pb-70{
    padding-bottom: 70px;
}
.start-date{
    color: green
}
</style>



// WEBPACK FOOTER //
// src/components/login/login.vue